import './index.sass';

export default () => {
  let registrationValidation = function() {
    if ($('.js-registration').length === 0) return;

    if ($('.js-registration').find('.input').val().length === 0) {
      $('.js-registration').find('.registration__button').prop('disabled', true);
    }

    return $('body').on('keyup', '.js-registration .input', function() {
      if ($(this).val().length >= 1) {
        if ($(this).hasClass('input-error') || $(this).hasClass('error')) {
          $(this).removeClass('input-error');
          $(this).removeClass('error');
          $(this).parent().find('.bubble-error').fadeOut(200, function() {
            return $(this).remove();
          });
        }
        $('.js-registration').find('.registration__button').prop('disabled', false);
      } else if ($(this).val().length === 0) {
        $('.js-registration').find('.registration__button').prop('disabled', true);
      }
    });
  };

  let registrationConfirm = function() {
    if ($('.js-registration-confirm').length === 0) return;
    console.log(1);
    if ($('.js-registration-confirm').find('.input[type="text"]').val().length === 0 || $('.js-registration-confirm').find('.input[type="password"]').val().length === 0) {
      $('.js-registration-confirm').find('.registration__button').prop('disabled', true);
    }

    return $('body').on('keyup', '.js-registration-confirm .input', function() {
      if ($(this).val().length >= 1) {
        if ($(this).hasClass('input-error')) {
          $(this).removeClass('input-error');
          $(this).parent().find('.bubble-error').fadeOut(200, function() {
            return $(this).remove();
          });
        }
        if ($('.js-registration-confirm').find('.input[type="text"]').val().length >= 1 && $('.js-registration-confirm').find('.input[type="password"]').val().length >= 1) {
          $('.js-registration-confirm').find('.registration__button').prop('disabled', false);
        }
      } else if ($(this).val().length === 0) {
        $('.js-registration-confirm').find('.registration__button').prop('disabled', true);
      }
    });
  };

  registrationValidation();
  registrationConfirm();
};
